<template>
  <div>
    <label class="mt-5 mb-2 inline-block">{{ label }}:</label>
      <froala ref="editor" :tag="'textarea'" :config="config" :value="value" @input="input" class="bg-red"></froala>
      <div v-if="error" class="form-error">{{ error[0] }}</div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      config: {
        editorClass: 'styled-content',

        // General
        key: window.siteVars.froalaKey || '',

        heightMin: 200,
        pasteAllowedStyleProps: [],
        wordPasteKeepFormatting: false,
        pastePlain: true,

        // Html
        // htmlAllowedTags: ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'blockquote', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hgroup', 'hr', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'menu', 'menuitem', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'pre', 'progress', 'queue', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'style', 'section', 'select', 'small', 'source', 'span', 'strike', 'strong', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr'],
        // htmlAllowedEmptyTags: ['textarea', 'a', 'iframe', 'object', 'video', 'style', 'script', '.fa', '.fr-emoticon', '.fr-inner', 'path', 'line', 'hr'],
        // htmlAllowedAttrs: ['id', 'title', 'href', 'alt', 'src', 'url', 'class'],
        // htmlDoNotWrapTags: ['script', 'style', 'img'],

        // Links
        linkEditButtons: ['linkEdit', 'linkRemove', 'linkOpen'],

        // Video
        videoInsertButtons: ['videoBack', '|', 'videoByURL'],
        videoResponsive: true,
        videoDefaultWidth: 0,

        // Images
        imageInsertButtons: ['imageBack', '|', 'imageUpload'],
        imageEditButtons: ['imageReplace', 'imageRemove', '|', 'imageAlt', '|', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove'],
        imageDefaultWidth: 0,
        imageUploadURL: '/inline-images',
        imageUploadParams: {
            imageable_type: this.imageableType,
            _token: csrfToken
        },
        toolbarSticky: true,
        toolbarStickyOffset: 0,
        toolbarButtons: {
          'moreText': {
            'buttons': ['paragraphFormat', 'clearFormatting', '|', 'bold', 'italic', 'underline', '|', 'formatOLSimple',  'formatUL',  '|',  'alignLeft', 'alignCenter', 'alignRight', 'alignJustify','quote'],
            'buttonsVisible': 7
          },
          'moreRich': {
            'buttons': ['insertLink', this.insertMedia ? 'insertImage' : '', this.insertMedia ? 'insertVideo' : '', 'specialCharacters', 'emoticons', 'fontAwesome', 'insertTable'],
            'buttonsVisible': this.insertMedia ? 4 : 1
          },
          'moreMisc': {
            'buttons': ['undo', 'redo', 'fullscreen', 'html', 'print', 'getPDF', 'spellChecker', 'selectAll', 'help'],
            'align': 'right',
            'buttonsVisible': 4
          },
        },

        quickInsertEnabled: this.insertMedia,
        quickInsertButtons: ['image', 'video', 'table'],

        tableEditButtons: ['tableRows', 'tableColumns', 'tableCells', 'tableCellVerticalAlign', 'tableRemove'],

        paragraphFormat: {
            N: 'Paragraph',
            H2: 'Heading 2',
            H3: 'Heading 3',
            H4: 'Heading 4',
            H5: 'Heading 5',
        },

        events: {
            'image.removed': ($img) => {
              axios.delete('/inline-images/', { data: { src: $img.attr('src') } })
                .then(data => {
                  console.log('Image deleted from the server')
                })
            }
        }

      },
      model: 'Edit Your Content Here!'
    }
  },
  props: {
    insertMedia: '',
    imageableId: null,
    imageableType: {
      'default': 'Blog'
    },
    value: "",
    error: false,
    label: "",
  },

  methods: {
    
    input(value){
      this.$emit('input', value)
    }

  },
  mounted() {
  }
};
</script>